import { createContext, useContext } from 'react';
import { ApiClient } from '../types';

export const ApiAdminClientContext = createContext<ApiClient>(undefined!);

export function useApiAdminClient() {
  return useContext(ApiAdminClientContext);
}
